import { Component, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import StepZilla from "react-stepzilla";
import "./multistep.css";
import ImagesAndFilesComp from "./ImagesAndFilesComp";
import ToastContainer from "react-bootstrap/ToastContainer";
import { Toast } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import ProgressBar from "react-bootstrap/ProgressBar";
import { PatientService, DoctorService } from "../../services";
import BootstrapModal from "react-bootstrap/Modal";

async function timeout(delay) {
  return new Promise((res) => setTimeout(res, delay));
}

function formatDate(date) {
  let current = new Date(date);
  let newDate =
    current.getFullYear() +
    "/" +
    parseInt(current.getMonth() + 1) +
    "/" +
    current.getDate();
  console.log(newDate);
  return newDate;
}

function getToday() {
  let current = new Date();
  return current.toISOString().substring(0, 10);
}

const PatientDetailsPart = (props) => {
  return (
    <Form>
      <Form.Group className="mb-3">
        <Form.Label>FirstName:</Form.Label>
        <Form.Control
          type="text"
          name="FirstName"
          value={props.patientDetails.FirstName}
          onChange={(e) => props.onSetValue("FirstName", e)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>FamilyName:</Form.Label>
        <Form.Control
          type="text"
          name="FamilyName"
          value={props.patientDetails.FamilyName}
          onChange={(e) => props.onSetValue("FamilyName", e)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>BirthDate:</Form.Label>
        <Form.Control
          type="date"
          name="BirthDate"
          value={props.patientDetails.BirthDate}
          onChange={(e) => props.onSetValue("BirthDate", e)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Gender:</Form.Label>
        <Form.Select
          aria-label="Default select example"
          value={props.patientDetails.Gender}
          onChange={(e) => props.onSetValue("Gender", e)}
        >
          <option value=""></option>
          <option value="1">Male</option>
          <option value="2">Female</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Clinic Name:</Form.Label>
        <Form.Select
          aria-label="Default select example"
          value={props.patientDetails.ClinicId}
          onChange={(e) => props.onSetValue("ClinicId", e)}
        >
          <option value="">Please Select Clinic Name</option>
          {props.clinics.map((clinic) => {
            return (
              <option key={clinic.Id} value={clinic.Id}>
                {clinic.ClinicName}
              </option>
            );
          })}
        </Form.Select>
      </Form.Group>
    </Form>
  );
};

class TreatmentDetailsPart extends Component {
  constructor(props) {
    super(props);

    this.isValidated = this.isValidated.bind(this);
  }

  async isValidated() {
    return this.props.onSubmitCallback();
  }

  render() {
    return (
      <div>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Note:</Form.Label>
            <Form.Control
              as="textarea"
              name="Note"
              rows="5"
              value={this.props.treatmentNote}
              onChange={(e) => {
                this.props.setTreatmentNote(e.target.value);
              }}
            />
          </Form.Group>
        </Form>
      </div>
    );
  }
}

export default function NewPatientForm(props) {
  const onSetValue = (id, event) => {
    patientDetails[id] = event.target.value;
    setPatientDetails({ ...patientDetails });
  };

  const [previews, setPreviews] = useState({});
  const [clinics, setClinics] = useState([]);
  const [showSpinner, setShowSpinner] = useState(false);
  const [patientDetails, setPatientDetails] = useState({
    FirstName: "",
    FamilyName: "",
    BirthDate: getToday(),
    Gender: 1,
    ClinicId: 0,
  });
  const [resultMessage, setResultMessage] = useState("");
  const [showResultMessage, setShowResultMessage] = useState(false);
  const [messageType, setMessageType] = useState("Primary");
  const [treatmentNote, setTreatmentNote] = useState("");
  const [contentType, setContentType] = useState("");
  const [progressPercent, setProgressPercent] = useState(0);

  const id = useParams().id;

  const showMessage = (message, type) => {
    setResultMessage(message);
    setMessageType(type);
    setShowResultMessage(true);
  };

  async function onSubmit() {
    if (showSpinner == true) return false;
    // check fields
    let errorMessage = ""
    if (id == "new" && (patientDetails.FirstName == "" ||
        patientDetails.FamilyName == "" ||
        patientDetails.ClinicId == "")) {
      showMessage("Lütfen hasta bilgilerini eksiksiz giriniz", "danger")
      return false
    } else if (contentType == "") {
      showMessage("Lütfen ölçü türünü seçiniz.", "danger")
      return false
    } else if (treatmentNote == "") {
      showMessage("Lütfen tedavi detaylarını doldurunuz.", "danger")
      return false
    } else if (Object.keys(previews).length === 0) {
      showMessage("Lütfen hasta fotoğraflarını da yükleyiniz.", "danger")
      return false
    }

    // uppercase fields
    patientDetails.FirstName = patientDetails.FirstName.charAt(0).toUpperCase() + patientDetails.FirstName.slice(1)
    patientDetails.FamilyName = patientDetails.FamilyName.charAt(0).toUpperCase() + patientDetails.FamilyName.slice(1)

    setProgressPercent(0);
    setShowSpinner(true);

    // upload images
    const resultImages = await PatientService.uploadImages(
      previews,
      setProgressPercent
    );
    console.log(resultImages);

    let patientId = id;
    // insert patient
    if (id == "new") {
      const result = await PatientService.addNewPatient(patientDetails);
      patientId = result[0].Id;
      console.log(patientId);
    }

    const imageInsertResult = await PatientService.insertImageMetaData(
      patientId,
      treatmentNote,
      contentType,
      resultImages
    );
    console.log(imageInsertResult);

    setShowSpinner(false);
    showMessage("Your patient uploaded successfully", "primary");

    return true;
  }

  useEffect(() => {
    // upload images
    const result = DoctorService.getClinicsList().then((clinics) => {
      setClinics(clinics);
      console.log(clinics);
    });
  }, []);

  const ConfirmFormPart = () => {
    return (
      <div className="text-center">
        <div className="text-center">
          You succesfully uploaded your patient. We will get back to you soon.
        </div>
        <Link to="/patients" className="btn btn-primary mt-5">
          Go To Patient List
        </Link>
      </div>
    );
  };

  const page1 = {
    name: "Patient Details",
    component: (
      <PatientDetailsPart
        patientDetails={patientDetails}
        clinics={clinics}
        onSetValue={onSetValue}
      />
    ),
  };
  const page2 = {
    name: "Images",
    component: (
      <ImagesAndFilesComp
        previews={previews}
        contentType={contentType}
        onSetPreviews={setPreviews}
        onContentType={setContentType}
      />
    ),
  };
  const page3 = {
    name: "Treatment Notes",
    component: (
      <TreatmentDetailsPart
        preview={previews}
        patientDetails={patientDetails}
        setTreatmentNote={setTreatmentNote}
        onSubmitCallback={onSubmit}
      />
    ),
  };
  const page4 = { name: "Confirmation", component: <ConfirmFormPart /> };

  const temp = [page2, page3, page4];

  let head = [];
  if (id == "new") head.push(page1);

  const steps = head.concat(temp);

  return (
    <div className="row" style={{ justifyContent: "center" }}>
      <div className="col-12 col-md-8">
        <div className="step-progress">
          <StepZilla
            steps={steps}
            stepsNavigation={false}
            nextTextOnFinalActionStep={"Save"}
            prevBtnOnLastStep={false}
          />
        </div>
      </div>

      {showSpinner && (
        <BootstrapModal show={showSpinner}>
          <BootstrapModal.Body>
            <ProgressBar variant="warning" animated now={progressPercent} />
          </BootstrapModal.Body>
        </BootstrapModal>
      )}

      <ToastContainer className="mb-5 position-fixed" position="bottom-center">
        <Toast
          onClose={() => setShowResultMessage(false)}
          show={showResultMessage}
          bg={messageType}
          delay={3000}
          autohide
        >
          <Toast.Body>{resultMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
}
